import React, { useEffect, useState } from 'react';
import { FadeLoader } from 'react-spinners';
import { create } from 'apisauce';

import APModal from 'components/Modal/APModal';
import { styledTheme } from 'globalStyles/theme';
import { getAuthToken } from 'utils/cookies';

const token = getAuthToken();

export const CreateCustomTemplateProject = ({
  show = false,
  projectId,
  goToProject,
}) => {
  const [projectCreateStatus, setProjectCreateStatus] = useState('processing');
  const [timerId, setTimerId] = useState();

  useEffect(() => {
    if (projectId) {
      setTimerId(pollStatus(projectId, setProjectCreateStatus));
    }
  }, [projectId]);

  useEffect(() => {
    if (projectCreateStatus === 'completed') {
      clearInterval(timerId);
    }
  }, [projectCreateStatus]);

  return (
    <APModal
      open={show}
      title={projectCreateStatus === 'error' ? 'Uh oh!' : 'You\'re on a roll!'}
      name="custom-template-project-creation"
      actions={
        projectCreateStatus === 'completed' ? (
          <button
            className="button"
            onClick={() => goToProject(projectId)}
          >
            Let's Go
          </button>
        )
        :
        projectCreateStatus === 'error' ? (
          <button
            className="button"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        )
        :
        (
          <div className="spinner">
            <FadeLoader
              color={styledTheme.lighterGray}
              loading={projectCreateStatus === 'processing'}
              height={15}
              width={5}
              radius={5}
              margin={2}
            />
          </div>
        )
      }
    >
      {projectCreateStatus === 'error' ? (
        <p>Something went wrong when creating that project. Please reload and try again.</p>
      ) : (
        <p>Just a moment while we prepare this project for you.</p>
      )}
    </APModal>
  );
};

const pollStatus = (id, callback) => {
  const timerId = setInterval(() => checkStatus(id, callback), 3000);
  return timerId;
};

const checkStatus = async (id, callback) => {
  const api = create({
  baseURL: `${process.env.REACT_APP_AP_URL}/api/wedding/${id}`,
  headers: {
    'content-type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': `Bearer ${token}`,
  },
});
  const response = await api.get();
  if (!response.ok) {
    callback('error');
  }
  const { data } = response || {};
  const { pieces } = data || {};
  const { wedding } = pieces || {};
  const { creation_status } = wedding || {};
  callback(creation_status);
};
